/* eslint-disable react/no-array-index-key */
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

import { fromStringToNumber } from '../../utils/helpers'
import {
  ratingItem,
  ratings,
  ratingsName,
  // ratingStar,
} from './RatingItem.module.css'

// const stars = Array(5)
//   .fill()
//   .map((_, i) => (
//     <StaticImage
//       key={i}
//       alt="rating"
//       className={ratingStar}
//       loading="eager"
//       quality={100}
//       src="../../assets/icons/starIcon.png"
//     />
//   ))

const imagesArr = [
  <StaticImage
    key={0}
    alt="rating"
    loading="eager"
    quality={100}
    src="../../assets/icons/zorgkaartnederland.png"
  />,
  <StaticImage
    key={1}
    alt="rating"
    loading="eager"
    quality={100}
    src="../../assets/icons/kliniekervaringen.png"
  />,
  <StaticImage
    key={2}
    alt="rating"
    loading="eager"
    quality={100}
    src="../../assets/icons/google.png"
  />,
]

const RatingItem = ({ image, link, rating }) => {
  let ctaContent = link
  if (typeof link === 'string') {
    ctaContent = JSON.parse(link)
  }

  return (
    <li className={ratingItem}>
      <a
        className={ratingsName}
        href={ctaContent.target}
        rel="noreferrer"
        target="_blank"
      >
        {imagesArr[image]}
      </a>
      <div className={ratings}>
        <p>
          {fromStringToNumber(rating)}
          <span>+</span>
        </p>
        {/* <div>{stars}</div> */}
      </div>
    </li>
  )
}

export default RatingItem
